import PaymentHistoryWidget from '../components/Widgets/PaymentHistoryWidget';
import type { ConfigData } from '@plone/volto/types';

const applyPaymentHistorySettings = (config: ConfigData): ConfigData => {

  console.log('Applying payment history widgets config');
  config.widgets.widget.payment_history_widget = PaymentHistoryWidget;

  return config;
};

export default applyPaymentHistorySettings;
